<!--支付成功-->
<template>
  <div class="pay-result">
    <div class="page-pay-success"
         v-if="isPaySuccess">
      <div class="page-success-tag">
        <img src="../../../assets/img/ic_pay_success.png">
        <div class="page-success-tag-text">支付成功</div>
      </div>
      <div class="pay-money">{{payInfo.transactionAmount}}元</div>
      <div class="thank-tip">感谢您的使用，期待再次充电！</div>
      <div class="pay-result-cell">
        <div class="title">充电电量</div>
        <div class="value">{{payInfo.chargeElect}}度</div>
      </div>
      <div class="pay-result-cell">
        <div class="title">优惠</div>
        <div class="value">￥{{payInfo.totalDiscount}}</div>
      </div>
      <div class="pay-result-cell">
        <div class="title">总计</div>
        <div class="value">￥{{payInfo.transactionAmount}}</div>
      </div>
      <div class="pay-result-cell">
        <div class="title">充电站地址</div>
        <div class="value">{{payInfo.staAddress}}</div>
      </div>
      <div class="pay-result-cell">
        <div class="title">充电站名称</div>
        <div class="value">{{payInfo.staName}}</div>
      </div>
      <div style="margin:0.4rem">
        <pi-button type="primary"
                   @click="close"
                   block>关闭</pi-button>
      </div>
      <!-- <div class="button1" @click="close">关闭</div> -->
    </div>
    <div class="page-pay-abnormal"
         v-else>
      <div class="page-abnormal-tag">
        <img src="../../../assets/img/ic_pay_abnormal.png">
        <div class="page-abnormal-tag-text">订单异常</div>
      </div>
      <div class="abnormal-tip">抱歉，当前订单{{payInfo.orderNo}}无法进行支付,管理员将在0-3个工作日为您处理</div>
      <div class="pay-result-cell">
        <div class="title">充电站地址</div>
        <div class="value">{{payInfo.staAddress}}</div>
      </div>
      <div class="pay-result-cell">
        <div class="title">充电站名称</div>
        <div class="value">{{payInfo.staName}}</div>
      </div>
      <div style="margin:0.4rem">
        <pi-button type="primary"
                   @click="close"
                   block>关闭</pi-button>
      </div>
      <!-- <div class="button1" @click="close">关闭</div> -->
    </div>
  </div>
</template>

<script>
import { getOrderafterSettle, upOrderRead } from "@/common/api/index";
export default {
  name: "pay-success",
  data() {
    return {
      isPaySuccess: true,
      payInfo: {}
    };
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo;
    if (this.orderNo) {
      this.getOrderafterSettle();
      this.upOrderRead([this.orderNo])
    }
    // this.isPaySuccess = this.$route.params.payResult;
  },
  methods: {
    upOrderRead(orderNos){
      console.log(orderNos)
      upOrderRead({
        orderNos:orderNos
      }).then(()=>{
      })
    },
    close() {
      this.$router.replace({
        name: "home",
      })
      // this.$router.go(-1);
    },
    getOrderafterSettle() {
      getOrderafterSettle({
        orderNo: this.orderNo
      })
        .then(data => {
          if (data.status === this.$config.ajaxStatus) {
            this.payInfo = data.data[0];
            if(data.data[0].orderStatus == 4 ){
              this.isPaySuccess = false;
            }else{
              this.isPaySuccess = true;
            }
            
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.page-pay-success {
  padding: 0 0.2rem;
  .page-success-tag {
    margin: 0.37rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.56rem;
      height: 0.56rem;
      font-size: 0.58rem;
    }
    .page-success-tag-text {
      margin: 0 0.2rem;
      font-size: 0.42rem;
      color: #14cc80;
    }
  }
  .pay-money {
    font-size: 0.42rem;
    color: #14cc80;
    text-align: center;
    padding-bottom: 0.2rem;
  }
  .thank-tip {
    font-size: 0.3rem;
    color: #666666;
    text-align: center;
  }
  .pay-result-cell {
    display: flex;
    align-items: center;
    background: #f8f4f5;
    padding: 0.08rem;
    margin-top: 0.25rem;
    .title {
      font-size: 0.28rem;
      color: #999999;
      margin-right: 0.2rem;
    }
    .value {
      font-size: 0.26rem;
      color: #666666;
      flex: 1;
      text-align: end;
    }
  }
}

.page-pay-abnormal {
  padding: 0 0.2rem;
  .page-abnormal-tag {
    margin: 0.37rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 0.56rem;
      height: 0.56rem;
      font-size: 0.58rem;
    }
    .page-abnormal-tag-text {
      margin: 0 0.2rem;
      font-size: 0.42rem;
      color: #f95450;
    }
  }
  .abnormal-tip {
    font-size: 0.3rem;
    color: #666666;
    padding: 0 0.9rem;
  }
  .pay-result-cell {
    display: flex;
    align-items: center;
    background: #f8f4f5;
    padding: 0.08rem;
    margin-top: 0.25rem;
    .title {
      font-size: 0.28rem;
      color: #999999;
      margin-right: 0.2rem;
    }
    .value {
      font-size: 0.26rem;
      color: #666666;
      flex: 1;
      text-align: end;
    }
  }
}
</style>
